/**
 * Clears all session-related data from the browser.
 * This includes localStorage, sessionStorage, and attempts to clear auth cookies.
 */
export const clearAllSessionData = () => {
    if (typeof window !== 'undefined') {
      // Clear all storage
      localStorage.clear();
      sessionStorage.clear();

      // Attempt to clear cookies by setting them to expired
      // Note: HttpOnly cookies cannot be cleared from client-side JS, 
      // but we clear what we can to be thorough.
      try {
        const cookies = document.cookie.split('; ');
        const hostname = window.location.hostname;
        const isProdOrDev = hostname.endsWith('redtab.xyz');
        const domain = isProdOrDev ? '.redtab.xyz' : hostname;
        
        for (const cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            if (!name) continue;
            
            // Clear for both current domain and common domain structure
            document.cookie = `${name}=; Path=/; Domain=${domain}; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
            document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
        }
      } catch (e) {
        console.warn('Error clearing cookies:', e);
      }
    }
  };
